import { Button } from '@meitu/saas-ui';
import { traverseTrees } from '@meitu/saas-editor-core/es/utils/tree-kit';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { type IEditor } from '@/instance';

const ClearMarkBtn: React.FC<{
    editor: IEditor;
}> = ({ editor }) => {
    const clearMark = () => {
        const stageIndex = editor.services.frame.getActiveIndex();
        const stage = editor.services.frame.getLayersByIndex(stageIndex);
        const extraInfo = editor.services.frame.getExtraInfo(stageIndex);
        editor.services.frame.setExtraInfo(stageIndex, { ...extraInfo, extraInfo: undefined });
        traverseTrees(stage, (layer: ILayerProps) => {
            if (layer.extraInfo && layer.extraInfo.label) {
                delete layer.extraInfo.label;
                editor.services.frame.addOrUpdateLayer({ ...layer });
            }
        });
    };

    return (
        <div style={{ marginRight: '10px' }}>
            <Button type="primary" data-blue onClick={clearMark}>
                清空打标
            </Button>
        </div>
    );
};

export default ClearMarkBtn;
